import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { useActions } from '../../../hooks/useActions';

export const useSessionClientName = () => {
  const location = useLocation();
  const { selectedSession } = useSelector((state) => state.sessions);
  const { clients } = useSelector((state) => state.clients);
  const { getAllClients } = useActions();

  const therapistOrgId = selectedSession?.therapist?.organizationId;

  const { sessionClientName } = location.state || {};
  const [clientName, setClientName] = useState(sessionClientName);

  useEffect(() => {
    if (!sessionClientName && clients.length <= 0 && therapistOrgId)
      getAllClients(`filter[where][organizationId]=${therapistOrgId}`);

    if (!sessionClientName && clients.length > 0)
      setClientName(
        clients?.find((client) => client?.id === selectedSession?.clientId)
          ?.name,
      );
    if (clientName && clients.length > 0 && selectedSession)
      setClientName(
        clients?.find((client) => client?.id === selectedSession?.clientId)
          ?.name,
      );
  }, [clients, sessionClientName, therapistOrgId, selectedSession]);

  return [clientName, setClientName];
};
